import React, { Component } from 'react';

// Components
import WeatherItem from './WeatherItem.js';
import { tsLiveServerENV } from '../ENV.js';

const secondInMs = 1000;
const minuteInMs = 60 * secondInMs;
const expoBackoffMin = 1000;
const expoBackoffMax = minuteInMs * 15;

class Weather extends Component {
	constructor(props) {
		super(props);

		let reqRate = minuteInMs * 60;
		if (this.props.request_rate && typeof this.props.request_rate === 'number') {
			reqRate = this.props.request_rate * secondInMs;
		}

		this.state = {
			data:            	[],
			request_rate:    	reqRate,
			request_timer:   	false,
			request_backoff:	expoBackoffMin,
			css:         		props.CSSModules[props.condor_render_name],
			wrapperWidth: 		'',
			itemWidth:   		'',
			content:     		'hidden',
			animated:    		'',
			boxGap:      		this.props.box_gap,
			showCurrentWeather: this.props.show_current_weather,
			timerInterval: 		this.props.animation_interval,
			timerRunning:  		false,
			weatherScrollCount: 0,
			network: 			1,
			offlineMins: 		0
		};
	}

	componentDidMount() {
		setTimeout(() => {
			this.getData();
		}, 1500);
	}

	componentWillUnmount() {
		clearInterval(this.timer);
		clearInterval(this.state.request_timer);
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.request_rate !== this.props.request_rate &&
			typeof this.props.request_rate === 'number'
		) {
			let request_rate = this.props.request_rate * secondInMs;
			this.setState({ request_rate });
		}

		if (prevProps.days_to_show !== this.props.days_to_show) {
			let wrapper = document.getElementById(`wrapper_${this.props.component_name}`);
			let contWidth = wrapper.offsetWidth;
			let newContainerWidth = wrapper.offsetWidth;
			let numDays = this.props.days_to_show;
			let scrollAmount = 0;
			let modifier = 0;
	
			if (this.props.day_config === 1) {
				modifier = this.props.line_width_px;
			} else if (this.props.day_config === 2) {
				modifier = this.props.box_gap;
			}
	
			let adjustedContWidth = contWidth - ((numDays - 1) * modifier);
			let dayWidth = Math.floor(adjustedContWidth / numDays);
			newContainerWidth = (dayWidth * numDays) + ((numDays - 1) * modifier);
			scrollAmount = dayWidth + modifier;
	
			this.setState({
				wrapperWidth: newContainerWidth,
				itemWidth:    dayWidth,
				scrollAmount: scrollAmount,
			});
		}
	}

	getData = () => {
		const target = `${tsLiveServerENV}/weather?zip=${this.props.zip_code}`;

		const getFileSuccess = (jsonData) => {
			if (!Array.isArray(jsonData)) {
				getFileFail(new Error('Data format not an array.'));
				return;
			}

			let timer = setTimeout(this.getData, this.state.request_rate);

			this.setState({
				data: jsonData,
				request_backoff: expoBackoffMin,
				request_timer:   timer
			});

			// Restart local animation if relevant
			this.stopAnimatedWeatherTimer();
			this.startAnimatedWeatherTimer();
		};

		const getFileFail = (error) => {
			console.error(error);
			this.stopAnimatedWeatherTimer();

			let currentBackoff = this.state.request_backoff;
			let nextBackoff = currentBackoff * 2;
			if (nextBackoff > expoBackoffMax) {
				nextBackoff = expoBackoffMax;
			}

			let timer = setTimeout(this.getData, currentBackoff);

			this.setState({
				request_backoff: nextBackoff,
				request_timer:   timer
			});
		};

		try {
			fetch(target)
				.then((response) => response.json())
				.then((jsonData) => getFileSuccess(jsonData))
				.catch((err) => getFileFail(err));
		} catch (err) {
			getFileFail(err);
		}
	};

	initializeScrollingContent = () => {
		// React 19 fix: Force layout flush with double RAF before reading DOM dimensions
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				const wrapper = document.getElementById(`wrapper_${this.props.component_name}`);
				if (!wrapper) {
					console.error('Weather: wrapper not found');
					return;
				}

				let contWidth = wrapper.offsetWidth;
				let newContainerWidth = wrapper.offsetWidth;
				let numDays = this.props.days_to_show;
				let scrollAmount = 0;
				let modifier = 0;

				if (this.props.day_config === 1) {
					modifier = this.props.line_width_px;
				} else if (this.props.day_config === 2) {
					modifier = this.props.box_gap;
				}

				let adjustedContWidth = contWidth - ((numDays - 1) * modifier);
				let dayWidth = Math.floor(adjustedContWidth / numDays);
				newContainerWidth = (dayWidth * numDays) + ((numDays - 1) * modifier);
				scrollAmount = dayWidth + modifier;

				this.setState({
					animated:     'animated',
					content:      'visible',
					wrapperWidth: newContainerWidth,
					itemWidth:    dayWidth,
					scrollAmount: scrollAmount,
				});
			});
		});
	}


	startAnimatedWeatherTimer = () => {
		if (!this.props.animation) {
			this.setState({ content: 'visible' });
			return;
		}

		// If day_count <= days_to_show, skip animation
		if (this.props.day_count <= this.props.days_to_show) {
			this.stopAnimatedWeatherTimer();
			this.initializeScrollingContent();
			console.log('Not enough days to animate; making content visible, no scrolling.');
			return;
		}

		// Otherwise, do an animation cycle
		const tick = (this.state.timerInterval || 10) * 1000;
		this.initializeScrollingContent();

		this.timer = setInterval(() => {
			this.animateContent();
		}, tick);
	};

	stopAnimatedWeatherTimer = () => {
		clearInterval(this.timer);
		this.setState({
			weatherScrollCount: 0,
			timerRunning: false,
		});
	};

	animateContent = () => {
		this.scrollContent();
		this.setState((prev) => ({
			weatherScrollCount: prev.weatherScrollCount + 1,
			timerRunning: true
		}));
	};

	/** Move the wrapper horizontally by `scrollAmount` and then rearrange the DOM. */
	scrollContent = () => {
		if (
			this.state.network === 1 ||
			(this.state.network === 0 && this.state.offlineMins <= 1440)
		) {
			if (this.props.day_config === 1) {
				// For "line" separation, fade out the old line
				const lineSeparatorClass = `line_${this.props.component_name}`;
				const lineSeparators = document.querySelectorAll(`.${lineSeparatorClass}`);
				if (lineSeparators && lineSeparators.length && lineSeparators[0]) {
					lineSeparators[0].classList.add('fadeWeather');
				}
			}

			const wrapper = document.getElementById(`wrapper_${this.props.component_name}`);
			if (wrapper) {
				wrapper.scrollBy(this.state.scrollAmount, 0);
			}

			setTimeout(() => {
				this.swapFirstDayToEnd();
			}, 500);
		}
	};

	/** Move the first day element to the end of the container for an endless scroll effect. */
	swapFirstDayToEnd = () => {
		const wrapper = document.getElementById(`wrapper_${this.props.component_name}`);
		if (!wrapper) {
			console.error('Weather: wrapper not found!');
			return;
		}

		// React 19 fix: Safer style access
		if (wrapper.style) {
			wrapper.style.scrollBehavior = 'auto';
		}

		const firstChunk = document.getElementById(`firstWeatherChunk_${this.props.component_name}`);
		const lastChunk = document.getElementById(`lastWeatherChunk_${this.props.component_name}`);
		if (!firstChunk || !lastChunk) {
			if (!firstChunk && !lastChunk) {
				console.error('Weather: both firstChunk and lastChunk not found!');
			} else if (!firstChunk) {
				console.error('Weather: firstChunk not found!');
			} else {
				console.error('Weather: lastChunk not found!');
			}
			return;
		}

		// If day_config = 1, we also handle line separators
		if (this.props.day_config === 1) {
			const lineSepLast = document.getElementById(`lineSeparatorLast_${this.props.component_name}`);
			if (lineSepLast && lineSepLast.after) {
				lineSepLast.after(firstChunk);
				lineSepLast.removeAttribute('id');
			}
		} else {
			// React 19 fix: Use optional chaining for DOM method
			if (lastChunk.after) {
				lastChunk.after(firstChunk);
			} else {
				console.warn('Weather: after() method not supported');
			}
		}

		lastChunk.removeAttribute('id');
		firstChunk.setAttribute('id', `lastWeatherChunk_${this.props.component_name}`);

		if (this.props.day_config === 1) {
			const lineSeparatorClass2 = `line_${this.props.component_name}`;
			const lineSeparators2 = document.querySelectorAll(`.${lineSeparatorClass2}`);
			if (lineSeparators2 && lineSeparators2.length) {
				lineSeparators2[0].setAttribute('id', `lineSeparatorLast_${this.props.component_name}`);
				lineSeparators2[0].classList.remove('fadeWeather');
				const lastWeatherChunk = document.getElementById(`lastWeatherChunk_${this.props.component_name}`);
				if (lastWeatherChunk && lastWeatherChunk.after) {
					lastWeatherChunk.after(lineSeparators2[0]);
				}
			}
		}

		const targetClass = `weatherDay_${this.props.component_name}`;
		let items = document.querySelectorAll(`.${targetClass}`);
		if (items && items.length) {
			items[0].setAttribute('id', `firstWeatherChunk_${this.props.component_name}`);
		}

		// React 19 fix: Use optional chaining for scrollTo
		// eslint-disable-next-line no-unused-expressions
		wrapper.scrollTo?.(0, 0);
		if (wrapper.style) {
			wrapper.style.scrollBehavior = 'smooth';
		}
	};

	render() {
		const css = this.state.css;
		const {
			content,
			animated,
			wrapperWidth,
			itemWidth,
			data
		} = this.state;

		// Custom classes
		let customClasses = '';
		if (this.props.custom_classes && this.props.custom_classes.length > 0) {
			this.props.custom_classes.forEach((element) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(element)) {
					customClasses += ` ${element}`;
				}
			});
		}

		// Modifier classes
		let modifierClasses = '';
		if (this.props.modifier_classes && this.props.modifier_classes.length > 0) {
			this.props.modifier_classes.forEach((element) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(element)) {
					modifierClasses += ` ${element}`;
				}
			});
		}

		let weatherItems = data.map((element, index) => {
			let day = this.props.day ? element.Name : '';
			let currentSkyConditions = element.CurrentSkyCondition;
			let skyConditions = element.SkyCondition;

			let tempHigh = this.props.high_low ? `${element.Temperature.HighF}°` : '';
			let tempLow  = this.props.high_low ? `${element.Temperature.LowF}°` : '';
			let humidity = this.props.humidity ? '87%' : '';
			let chanceOfPercip = this.props.chance_of_percip ? '8%' : '';
			let feelsLike = this.props.feels_like ? '83°' : '';
			let windChill = this.props.wind_chill ? '25°' : '';

			if (this.props.celsius) {
				tempHigh = element.Temperature.HighC;
				tempLow = element.Temperature.LowC;
				feelsLike = '-28'; // example
			}

			let weatherItemProps = {
				animation: 			this.props.animation,
				componentGroup:    	this.props.condor_component_group,
				configuration:     	this.props.condor_configuration,
				theme:             	this.props.condor_theme,
				name:             	this.props.component_name,
				index,
				icons:            	this.props.icons,
				dayCount:         	this.props.day_count,
				itemWidth,
				borders:          	this.props.line,
				borderColors:     	this.props.line_sep_color,
				box:              	this.props.box,
				boxBorderColor:   	this.props.box_border_color,
				boxBorderWidth:   	this.props.box_border_width,
				boxColor:         	this.props.box_color,
				boxGap:           	this.props.box_gap,
				itemFormat:       	this.props.item_format,
				day,
				dayConfig:        	this.props.day_config,
				showSkyConditions: 	this.props.sky_conditions,
				currentSkyConditions,
				skyConditions,
				tempHigh,
				tempLow,
				humidity,
				chanceOfPercip,
				feelsLike,
				windChill,
				animatedIcon:     	this.props.animated_icon,
				iconType:         	this.props.icon_type,
				line:             	this.props.line,
				lineWidthPx:      	this.props.line_width_px,
				lineColor:        	this.props.line_color,
				iconColor1:       	this.props.icon_color_1,
				iconColor2:       	this.props.icon_color_2,
				iconColor3:       	this.props.icon_color_3,
				tempCurrentC:     	`${element.Temperature.CurrC}°` || '°',
				tempCurrentF:     	`${element.Temperature.CurrF}°` || '°',
				css
			};

			return (
				<WeatherItem
					key={`${day || 'day'}_${index}`}
					{...weatherItemProps}
				/>
			);
		});

		let weatherNew = [];
		for (let i = 0; i < this.props.day_count; i++) {
			if (weatherItems[i]) {
				weatherNew.push(weatherItems[i]);
			}
		}

		if (this.state.showCurrentWeather && weatherItems.length > 0) {
			if (weatherNew.length === 1) {
				weatherNew.pop();
			}
			weatherNew.unshift(
				<WeatherItem
					key={`current_${this.props.component_name}`}
					{...weatherItems[0].props}
					isCurrentDay
					showCurrentWeather
					css={css}
				/>
			);
		}

		let wrapperStyle = {
			width: `${wrapperWidth}px`
		};

		if (this.state.network === 0 && this.state.offlineMins >= 1440) {
			return (
				<div
					id={`weather_${this.props.component_name}`}
					className={`weather ${css.cont} ${css[content]} ${modifierClasses} ${customClasses} ${css[this.props.theme_variation]}`}
				>
					<div
						id={`wrapper_${this.props.component_name}`}
						className={`weather_container ${css.container} ${css[animated]}`}
					>
						<div className={`weather_wrapper ${css.wrapper}`} />
					</div>
				</div>
			);
		}

		return (
			<div
				id={`weather_${this.props.component_name}`}
				className={`weather ${css.cont} ${modifierClasses} ${customClasses} ${css[content]} ${css[this.props.theme_variation]}`}
			>
				<div
					id={`wrapper_${this.props.component_name}`}
					style={wrapperStyle}
					className={`weather_container ${css.container} ${css[animated]}`}
				>
					<div className={`weather_wrapper ${css.wrapper}`}>
						{weatherNew}
					</div>
				</div>
			</div>
		);
	}
}

export default Weather;
